module.exports = __webpack_public_path__ + "img/user-icon.a2f89a1f.svg";